import { useState } from 'react'

import { Button, Grid, Card } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useLanguage } from '../../context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import StatusCard from '../../components/inspect/StatusCard' // Import the new StatusCard component

const useStyles = makeStyles(theme => ({
    container: {
        marginTop: 20,
        paddingBottom: 10,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: '#000',
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
    },
    header: {
        textAlign: 'center'
    },
    headerText: {
        margin: 0
    },
    cardContainer: {
        width: '50%',
        textAlign: 'center',
        paddingTop: 5,
        paddingLeft: 10,
        paddingBottom: 5,
        paddingRight: 5
    },
    cardContainerRight: {
        width: '50%',
        textAlign: 'center',
        paddingTop: 5,
        paddingLeft: 5,
        paddingBottom: 5,
        paddingRight: 10
    },
    cardContent20: {
        width: '20%',
        textAlign: 'center',
        paddingTop: 5,
        paddingLeft: 10,
        paddingBottom: 5,
        paddingRight: 5
    },
    cardContent80: {
        width: '80%',
        textAlign: 'center',
        paddingTop: 5,
        paddingLeft: 5,
        paddingBottom: 5,
        paddingRight: 5
    },
    cardText: {
        fontSize: 12
    },
    cardTextMargin: {
        fontSize: 12,
        marginTop: '0.5rem',
        marginBottom: 0
    }
}))

const Inspects = () => {
    const { dictionary } = useLanguage()

    const classes = useStyles()

    const inspectionStatuses = [
        { color: '#27AE60', label: 'Aceptadas', value: 10, onClick: () => console.log('Ver Aceptadas') },
        { color: '#333333', label: 'Completadas', value: 3, onClick: () => console.log('Ver Completadas') },
        { color: '#F2C94C', label: 'En Proceso', value: 1, onClick: () => console.log('Ver En Proceso') },
        { color: '#EB5757', label: 'Pendientes', value: 0, onClick: () => console.log('Ver Pendientes') }
    ]

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <h2 className={classes.headerText}>
                    Inspección
                </h2>
            </div>

            <Grid container spacing={1}>
                <div className={classes.cardContainer}>
                    <Card elevation={0}>
                        <Grid container spacing={1}>
                            <div className={classes.cardContent20}>
                                <h2>
                                    14
                                </h2>
                            </div>
                            <div className={classes.cardContent80}>
                                <p className={classes.cardText}>
                                    Alertas totales durante el turno
                                </p>
                            </div>
                        </Grid>
                    </Card>
                </div>
                <div className={classes.cardContainerRight}>
                    <Card elevation={0}>
                        <Grid container spacing={1}>
                            <div className={classes.cardContent20}>
                                <h2>
                                    0
                                </h2>
                            </div>
                            <div className={classes.cardContent80}>
                                <p className={classes.cardTextMargin}>
                                    Inspecciones pendientes en la semana
                                </p>
                            </div>
                        </Grid>
                    </Card>
                </div>

                {inspectionStatuses.map((status, index) => (
                    <StatusCard key={index} {...status} />
                ))}
            </Grid>
        </div>
    )
}

export default Inspects
